import { ChangeProjectionService, Roi } from '@analysis/domain';
import { type ReadableRoiRepository, type RoiChangesRepository } from '../../ports';

export interface ListChangedRoisPayload {
  sampleId: string;
  creatorId: string;
}

export class ListChangedRoisUseCase {
  constructor(
    private readonly roiChanges: RoiChangesRepository,
    private readonly roiRepository: ReadableRoiRepository
  ) {}

  public async execute(payload: ListChangedRoisPayload): Promise<Roi[]> {
    const changes = await this.roiChanges.getForSampleAndAnalyst(payload.sampleId, payload.creatorId);

    const serverIds = changes.filter((c) => !(c.isNew && c.snapshot)).map((c) => c.id);
    const fetched = serverIds.length > 0 ? await this.roiRepository.batchGetByIds(serverIds) : new Map<string, Roi>();

    const rois: Roi[] = [];

    for (const change of changes) {
      if (change.isNew && change.snapshot) {
        rois.push(change.snapshot);
        continue;
      }

      const baseline = fetched.get(change.id);

      if (!baseline) continue;

      rois.push(ChangeProjectionService.applyChanges(baseline, change));
    }

    return rois;
  }
}
